import { c as _c } from "react/compiler-runtime";
import React, { PropsWithChildren, FunctionComponent } from 'react';
import { CardListItem, CardListItemProps } from 'record-it-components/cardList/CardListItem/CardListItem';
import { CardListItemIconButton } from 'record-it-components/cardList/CardListItemIconButton/CardListItemIconButton';
import { CardListItemTitle } from 'record-it-components/cardList/CardListItemTitle/CardListItemTitle';
import { useModalOpened } from 'record-it-components/hooks/useModalOpened/useModalOpened';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { UserGroup } from '../../../classes/entities/UserGroup/userGroupTypes';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import { useUserGroupDeleteHandler } from '../../../hooks/entity/deleteHandler/useUserGroupDeleteHandler';
import { EditUserGroupDialog } from '../EditUserGroupDialog/EditUserGroupDialog';
export type UserGroupListItemProps = PropsWithChildren<CardListItemProps> & {
  userGroup: UserGroup;
};
export const UserGroupListItem: FunctionComponent<UserGroupListItemProps> = React.memo(props => {
  const $ = _c(24);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let remainingProps;
  let userGroup;
  if ($[2] !== t0) {
    ({
      userGroup,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = remainingProps;
    $[4] = userGroup;
  } else {
    remainingProps = $[3];
    userGroup = $[4];
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      closeOnBackDropClick: true
    };
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    open: openEditDialog,
    close: closeEditDialog,
    modalProps
  } = useModalOpened(t1);
  const handleDeleteClick = useUserGroupDeleteHandler(userGroup);
  let t2;
  if ($[6] !== userGroup.name) {
    t2 = <CardListItemTitle>{userGroup.name}</CardListItemTitle>;
    $[6] = userGroup.name;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== handleDeleteClick) {
    t3 = <CardListItemIconButton {...iconConfigurations.prefixed.listItem.deleteIcon} onClick={handleDeleteClick} data-testid="UserGroupListItem.DeleteButton" />;
    $[8] = handleDeleteClick;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== openEditDialog) {
    t4 = <CardListItemIconButton {...iconConfigurations.prefixed.listItem.editInDialogIcon} onClick={openEditDialog} />;
    $[10] = openEditDialog;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== remainingProps || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <CardListItem {...remainingProps}>{t2}{t3}{t4}</CardListItem>;
    $[12] = remainingProps;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== closeEditDialog || $[18] !== modalProps || $[19] !== userGroup) {
    t6 = <EditUserGroupDialog {...modalProps} userGroup={userGroup} onAccept={closeEditDialog} />;
    $[17] = closeEditDialog;
    $[18] = modalProps;
    $[19] = userGroup;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t5 || $[22] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
});